import { Component, OnInit,Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Cabinet_Interface, Empty_Cabinet_Interface } from 'src/app/Interface/Cabinet_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CabinetService } from 'src/app/Service/Cabinet/Cabinet.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CabinetForm',
  templateUrl: './CabinetForm.component.html',
  styleUrls: ['./CabinetForm.component.scss']
})
export class CabinetFormComponent implements OnInit {

  Token: String = ""
  @Input() inner_Cabinent:Cabinet_Interface=Empty_Cabinet_Interface()

  constructor(
    private Cabinet_Service:CabinetService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.FormCabinet=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      Dsc:new FormControl(null,Validators.required),
    })

    this.get_Form_Title().setValue(this.inner_Cabinent.title)
    this.get_Form_Dsc().setValue(this.inner_Cabinent.dsc)

    this.Nav_Service.CheckValidPage(this.Token,1153).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  FormCabinet:FormGroup;

  get_Form_Title(){
    return this.FormCabinet.get('Title') as FormControl;
  }

  get_Form_Dsc(){
    return this.FormCabinet.get('Dsc') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitFormCabinet(){
    var Record:Cabinet_Interface =Empty_Cabinet_Interface()
    Record.id=this.inner_Cabinent.id
    Record.title=this.get_Form_Title().value
    Record.dsc=this.get_Form_Dsc().value
    this.InProccessing=true
    this.Cabinet_Service.AddEditCabinet(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered code number already exists in the list")
        }
        else {
          this.inner_Cabinent.id=data.id
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
